import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-navy-50 py-14 sm:py-20" data-id="element-131" data-mp="1ge8wgqsu0lu2">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-132" data-mp="2e06aaaw9o2zo">
        <SectionHeading eyebrow="Dubbi frequenti" title="Domande frequenti" data-id="element-133" data-mp="2dyda9eg5sh0n" />

        <div className="mt-10 space-y-2.5" data-id="element-134" data-mp="291wbzrf8wm9u">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-navy-900/10 bg-white" data-id="element-135" data-mp="1z372on1f0a57" data-mpi={i}>
                <h3 data-id="element-136" data-mp="sooas05anah3">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-navy-50/70 sm:px-5" data-id="element-137" data-mp="sl0eit8gs9yo">
                    <span className="text-[14px] font-extrabold leading-snug text-navy-900 sm:text-[15px]" data-id="element-138" data-mp="fkjorvhvdx6v">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-139" data-mp="6rgdntup5wfe" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-140" data-mp="1rk4lg757esz">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-141" data-mp="3jxgg20s5oeb0">
                      <p className="px-4 pb-4 text-[14px] leading-relaxed text-navy-900/70 sm:px-5" data-id="element-142" data-mp="1po1ib9kwd5f0">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10 flex justify-center" data-id="element-143" data-mp="2ddmbelarlj20">
          <CtaBlock label="Ottieni il Sistema Maestro della TRT™" note="Accesso digitale immediato · 19 EUR · Garanzia 7 giorni" data-id="element-144" data-mp="28hnjwou53kxd" />
        </div>
      </div>
    </section>;
}